import ReactPlayer from 'react-player/youtube';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Card, CardContent, Grid, TextField, Typography } from '@mui/material';
import { Color } from '../../../assets/color';
import RouteHeader from '../../../components/common/RouteHeader';
import DatatableHeading from '../../../components/heading/DatatableHeading';
import * as SuperadminActions from '../../../redux/actions/superadminAction';

const BusinessVideos = () => {
    const [mode, setMode] = useState('');
    const dispatch = useDispatch();
    const { businessVideoData } = useSelector(state => state?.superadminReducer);

    const [inputFieldDetail, setInputFieldDetail] = useState({ title: '', video_link: '' });
    const [inputFieldError, setInputFieldError] = useState({});

    const handleInputFieldDetail = (event) => setInputFieldDetail({ ...inputFieldDetail, [event?.target?.name]: event?.target?.value });  //* Handle Input Field : Data
    const handleInputFieldDetailError = (input, value) => setInputFieldError((prev) => ({ ...prev, [input]: value })); //* Handle Input Field : Error

    //* Handle Reset 
    const handleReset = () => {
        setInputFieldDetail({ title: '', video_link: '' });
        setMode('');
    };

    //* Handle Edit
    const handleEdit = (data) => {
        setInputFieldDetail({ title: data?.title, video_link: data?.video_link, id: data?._id });
        setMode('Edit');
    };

    //! Handle Submit : Create | Edit
    const handleSubmit = () => {
        console.log({ ...inputFieldDetail });

        if (mode == 'Edit') {
            handleReset()
            const payload = {
                id: inputFieldDetail?.id,
                data: { title: inputFieldDetail?.title, video_link: inputFieldDetail?.video_link, type: 'Business-Video' },
                onComplete: () => handleReset()
            }

            //! Dispatching API
            dispatch(SuperadminActions.updateVideo(payload));

        } else {
            const payload = {
                data: { title: inputFieldDetail?.title, video_link: inputFieldDetail?.video_link, type: 'Business-Video' },
                onComplete: () => handleReset()
            }
            console.log('Payload ::', payload);

            //! Dispatching API
            dispatch(SuperadminActions.createVideo(payload));
        }
    };

    useEffect(() => {
        //! Dispatching API
        dispatch(SuperadminActions.getVideos({ type: 'Business-Video' }));
    }, []);

    return (
        <>
            <RouteHeader title={`Business Videos`} sub_title={`Manage business videos for your platform`} />

            <div style={{ backgroundColor: Color.white, padding: "20px", borderRadius: "10px" }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <DatatableHeading title={'Video Management'} sub_title={'Add, update, or delete businesss videos'} />
                    <div onClick={() => setMode('Add')} style={{ fontSize: '14.5px', fontWeight: '500', padding: '10px 20px 9px 20px', borderRadius: '20px', background: "linear-gradient(to right,  #6653E8, #9544EB)", color: "#FFF", cursor: 'pointer' }}>{mode ? mode : 'Add'} New Video</div>
                </div>

                <Grid container spacing={3} sx={{ marginTop: '20px' }}>
                    {mode && <>
                        <Grid item lg={6} sm={12} md={12} xs={12}>
                            <TextField label="Title" variant="outlined" fullWidth
                                name="title"
                                value={inputFieldDetail?.title}
                                onChange={handleInputFieldDetail}
                                error={inputFieldError.title ? true : false}
                                helperText={inputFieldError.title}
                                onFocus={() => handleInputFieldDetailError("title", null)}
                                InputLabelProps={{ shrink: true }}
                            />
                        </Grid>

                        <Grid item lg={6} sm={12} md={12} xs={12}>
                            <TextField label="Videolink" variant="outlined" fullWidth
                                name="video_link"
                                value={inputFieldDetail?.video_link}
                                onChange={handleInputFieldDetail}
                                error={inputFieldError.video_link ? true : false}
                                helperText={inputFieldError.video_link}
                                onFocus={() => handleInputFieldDetailError("video_link", null)}
                                InputLabelProps={{ shrink: true }}
                            />
                        </Grid>

                        <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Grid container spacing={2} justifyContent="flex-end">
                                <Grid item>
                                    <div onClick={() => setMode('')} style={{ padding: '10px 20px', border: `1px solid ${Color.primary}`, borderRadius: '5px', backgroundColor: Color.white, color: Color.primary, fontSize: '14px', cursor: 'pointer' }}>Cancel</div>
                                </Grid>

                                <Grid item>
                                    <div onClick={handleSubmit} style={{ padding: '10px 20px', border: `1px solid ${Color.primary}`, borderRadius: '5px', background: "linear-gradient(to right,  #6653E8, #9544EB)", color: Color.white, fontSize: '14px', cursor: 'pointer' }}>{mode} Video</div>
                                </Grid>
                            </Grid>

                        </Grid>
                    </>}

                    {businessVideoData?.map((value, index) => (
                        <Grid item key={index} lg={4} md={6} sm={12} xs={12}>
                            <Card elevation={3} sx={{ borderRadius: 2, overflow: 'hidden' }}>
                                <Box sx={{ position: 'relative', paddingTop: '56.25%' /* 16:9 Aspect Ratio */ }}>
                                    <ReactPlayer url={value?.video_link} width="100%" height="100%" controls style={{ position: 'absolute', top: 0, left: 0, }} />
                                </Box>

                                <CardContent>
                                    <Typography variant="subtitle1" fontWeight="600" gutterBottom className='line-clamp-1'>
                                        Business {index + 1}: {value?.title}
                                    </Typography>

                                    <div style={{ display: 'flex', alignItems: 'center', gap: '5px', justifyContent: 'flex-start', marginTop: '15px' }}>
                                        <div onClick={() => handleEdit(value)} style={{ padding: '4px 15px 3px 15px', border: `1px solid ${Color.primary}`, borderRadius: '5px', backgroundColor: Color.white, color: Color.primary, fontSize: '12px', cursor: 'pointer' }}>Edit</div>
                                        <div onClick={() => dispatch(SuperadminActions.deleteVideo({ id: value?._id, type: 'Business-Video' }))} style={{ padding: '4px 15px 3px 15px', border: `1px solid ${Color.red}`, borderRadius: '5px', backgroundColor: Color.red, color: Color.white, fontSize: '12px', cursor: 'pointer' }}>Delete</div>
                                    </div>
                                </CardContent>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </div>
        </>
    )
}

export default BusinessVideos;